import React, { Fragment } from "react"

import { connect } from 'react-redux'

import { Tabs, Tab } from '@mui/material'

import SuAllMPP from './Sub/AllMPP'
import SuImplementasiMPP from './Sub/ImplementasiMPP'

class DetailListMpp extends React.Component {
    state = {
        TabValue: 0
    }
    handleTabChange = (e, newTabValue) => {
        this.setState({ TabValue: newTabValue })
    }
    render() {
        const {
            TabValue
        } = this.state

        const TabDataOrigin = [
            { TabLabel: 'MPP Berjalan', TabPanel: <SuAllMPP /> },
            { TabLabel: 'MPP Implementasi', TabPanel: <SuImplementasiMPP /> },
        ]

        const TabData = true ? TabDataOrigin : TabDataOrigin

        return (
            <Fragment>
                <Tabs
                    value={TabValue}
                    onChange={this.handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant={TabData.length > 6 ? "scrollable" : null}
                    scrollButtons="auto"
                // centered={TabData.length > 6 ? false : true}
                >
                    {TabData.map((item, index) => (
                        <Tab key={`Job_Tabs${index}`} label={item.TabLabel} />
                    ))}
                </Tabs>
                <div
                    style={{ margin: '5% 0 5% 0' }}
                >
                    {TabValue === 0 ? TabData[TabValue].TabPanel : null}
                    {TabValue === 1 ? TabData[TabValue].TabPanel : null}
                    {TabValue === 2 ? TabData[TabValue].TabPanel : null}
                    {TabValue === 3 ? TabData[TabValue].TabPanel : null}
                </div>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, {})(DetailListMpp)